(function ($) {
    /* to-do: Batch 2 Cleanup */
    initActiveCards();
    bindCardEvents();
    $(window).on("load", loadInitialAccordian);

    function loadInitialAccordian() {
        applyCustomColorsToAccordion();
        if ($("ul.sidebar-nav").length) {
            var urlParams = window.location.href.split("#");
            if (urlParams.length > 0) {
                var sectionToDisplay = sanitizeHtmlStrings(window.decodeURI(urlParams[1]));
                if ($("a[href='#" + sectionToDisplay + "']").length) {
                    $("a[href='#" + sectionToDisplay + "']").trigger("click");
                }
            }
        }
    }

    function collapseAll() {

    }

    function bindCardEvents() {
        $('body')
            .on('show.bs.collapse', '.accordion-group', function (e) {
                collapseAll();
                handleCardClick(e.target, true);
                if ($(e.currentTarget).attr('data-properties')) {
                    var customPropertiesOnShow = JSON.parse($(e.currentTarget).attr('data-properties'));
                    if (customPropertiesOnShow.EnableCustomizeColor && customPropertiesOnShow.EnableCustomizeColor.trim().toLowerCase() === 'true') {
                        if (e.currentTarget.className.includes('custom-accordion')) {
                            $(e.target).children('div.accordion-body').css('background-color', customPropertiesOnShow.AccordionBodyBackgroundColor);
                            $(e.target).children('div.accordion-body').css('color', customPropertiesOnShow.AccordionBodyFontColor);
                            $(e.target).parents().css('border-left', 'none');
                            $(e.target).siblings().children('a').children('.icon-circle-minus-id').removeClass('fa fa-plus');
                            $(e.target).siblings().children('a').children('.icon-circle-minus-id').addClass('fa fa-minus');
                            $(e.target).siblings().children('a').children('.icon-circle-minus-id.fa.fa-minus').css('background-color', customPropertiesOnShow.IconBackgroundColor);
                            $(e.target).siblings().children('a').children('.icon-circle-minus-id.fa.fa-minus').css('color', customPropertiesOnShow.IconColor);
                        }
                    }
                }


            })
            .on('hide.bs.collapse', '.accordion-group', function (e) {
                handleCardClick(e.target, false);
                if ($(e.currentTarget).attr('data-properties')) {
                    var customPropertiesOnHide = JSON.parse($(e.currentTarget).attr('data-properties'));
                    if (customPropertiesOnHide.EnableCustomizeColor && customPropertiesOnHide.EnableCustomizeColor.trim().toLowerCase() === 'true') {

                        //   $(e.target).siblings().children('a').children('.icon-circle-minus-id').css('background-image','none');
                        $(e.target).siblings().children('a').children('.icon-circle-minus-id').removeClass('fa fa-minus');
                        $(e.target).siblings().children('a').children('.icon-circle-minus-id').addClass('fa fa-plus');
                        $(e.target).siblings().children('a').children('.icon-circle-minus-id.fa.fa-plus').css('background-color', customPropertiesOnHide.IconBackgroundColor);
                        $(e.target).siblings().children('a').children('.icon-circle-minus-id.fa.fa-plus').css('color', customPropertiesOnHide.IconColor);
                    }
                }

            });
    }

    function handleCardClick(target, active) {
        var card = getCard($(target));
        setCardState(card, active);
        if (active) {
            $.publish(getEventName(card), getEventData(card));
        }
    }

    function getCard(child) {
        return child.closest('.accordion-item');
    }

    function initActiveCards() {
        $('.accordion-group .show').each(function () {
            setCardState(getCard($(this)), true);
        });
    }

    function setCardState(card, active) {
        card[active ? 'addClass' : 'removeClass']('active');
    }

    function getEventName(card) {
        return card.data('eventName') || card.closest('.accordion-group').data('eventName') || 'accordion';
    }

    function getEventData(card) {
        return card.data('eventData') || card.find('.accordion-header a:first').text();
    }
    function applyCustomColorsToAccordion() {
        if ($('.c01-accordion') || $('.c01-infinite-panels')) {
            $('.c01-accordion').each(function () {
                var self = $(this);
                if ($(this).attr('data-properties')) {
                    var customProperties = JSON.parse($(this).attr('data-properties'));
                    if (customProperties.EnableCustomizeColor && customProperties.EnableCustomizeColor.trim().toLowerCase() === 'true') {
                        $(this).addClass('custom-accordion');
                        $(this).find('.accordion-item .accordion-header i.icon-circle-minus-id').addClass('fa fa-plus');
                        $(this).find('.accordion-item .accordion-header').css('background-color', customProperties.AccordionTitleBackgroundColor);
                        $(this).find('.accordion-item .accordion-header>a').css('color', customProperties.AccordionTitleFontColor);
                        $(this).find('.accordion-item .accordion-header i.icon-circle-minus-id.fa.fa-plus').css('background-color', customProperties.IconBackgroundColor);
                        $(this).find('.accordion-item .accordion-header i.icon-circle-minus-id.fa.fa-plus').css('color', customProperties.IconColor);

                    }
                }
            });

            //9150
            if ($(".c01-global-infinite-panels")) {
                $(".c01-infinite-panels").each(function () {
                    var self = $(this);
                    if ($(this).attr("data-properties")) {
                        var customProperties = JSON.parse($(this).attr("data-properties"));
                        if (
                            customProperties.EnableCustomizeColor && customProperties.EnableCustomizeColor.trim().toLowerCase() === "true"
                        ) {
                            $(this).find(".accordion-item .accordion-header i.fa-chevron-up").css("color", customProperties.IconColor);
                            $(this).find(".accordion-item .accordion-header i.fa-chevron-up").css("background-color", customProperties.IconBackgroundColor);
                            self.find(".accordion-separator").each(function () {
                                $(this).find(".accordion-header:first").css("background-color", customProperties.AccordionTitleBackgroundColor);
                                $(this).find(".accordion-header:first>a").css("color", customProperties.AccordionTitleFontColor);
                                $(this).find(".country-card .accordion-header>a").css("color", customProperties.AccordionBodyFontColor);
                            });
                        }
                    }
                });
            }
            else {
                $('.c01-infinite-panels').each(function () {
                    var self = $(this);
                    if ($(this).attr('data-properties')) {
                        var customProperties = JSON.parse($(this).attr('data-properties'));
                        if (customProperties.EnableCustomizeColor && customProperties.EnableCustomizeColor.trim().toLowerCase() === 'true') {
                            $(this).addClass('custom-accordion-infinite');
                            $(this).find('.accordion-item .accordion-header i.icon-circle-minus-id').addClass('fa fa-plus');
                            $(this).find('.accordion-item .accordion-header').css('background-color', customProperties.AccordionTitleBackgroundColor);
                            $(this).find('.accordion-item .accordion-header>a').css('color', customProperties.AccordionTitleFontColor);
                            $(this).find('.accordion-item .accordion-header i.icon-circle-minus-id.fa.fa-plus').css('background-color', customProperties.IconBackgroundColor);
                            $(this).find('.accordion-item .accordion-header i.icon-circle-minus-id.fa.fa-plus').css('color', customProperties.IconColor);
                        }
                    }
                });
            }
        }
    }

    $(document).ready(function () {
        /* to check visible viewports */
        function isInViewport(el) {
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)

            );
        }
        /* to target active cards */
        $('.c01-accordion').on('shown.bs.collapse', '.accordion-item', function () {
            // Close other active accordion items
            if ($(this).closest('.c01-infinite-panels').length > 0) { return; }
            $('.c01-accordion .accordion-item').not(this).removeClass('active').find('.collapse').collapse('hide');

            // Add active class to the current accordion item
            $(this).addClass('active');

            // Scroll the current active accordion item into view if it's not visible
            var box = document.querySelector('.c01-accordion .accordion-item.active');
            var viewValue = isInViewport(box);
            if (!viewValue) {
                $('html, body').animate({
                    scrollTop: ($(".accordion-item.active").offset().top) - 50
                }, 'slow');
            }
        });
    });
}(window.jQuery));

function collapseAccordionForm(id) {
    if ($(id).parent('.active').length == 1) {
        var card_heading_expansion = $(id).prev().attr('data-form-ac-expansion-bgcolor');
        $(id).prev().css('background', card_heading_expansion);
        $(id).prev().find('.accordion-card-icon').removeClass('fa-plus-circle');
        $(id).prev().find('.accordion-card-icon').addClass('fa-minus-circle');
    }
    else {
        var card_heading_minimizing = $(id).prev().attr('data-form-ac-bgcolor');
        $(id).prev().css('background', card_heading_minimizing);
        $(id).prev().find('.accordion-card-icon').removeClass('fa-minus-circle');
        $(id).prev().find('.accordion-card-icon').addClass('fa-plus-circle');
    }
}


// Analytics

analytics.eventConfig.push(
    {
        "target": ".productLocator-accordian-angular",
        "events": [
            {
                "eventTarget": ".accordion-item.active a[data-bs-toggle*=collapse]",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentName": "accordion",
                    "componentId": "c01",
                    "eventType": "locator accordion expansion click",
                    "elementType": "accordion expansion box",
                    "elementText": ""
                }
            },
            {
                "eventTarget": ".accordion-item:not(.active) a[data-bs-toggle*=collapse]",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentName": "accordion",
                    "componentId": "c01",
                    "eventType": "locator accordion collapse click",
                    "elementType": "accordion expansion box",
                    "elementText": ""
                }
            }
        ]
    },
    {
        "target": ".component.c01-accordion:not(.productLocator-accordian):not(.global-accordion)",
        "events": [
            {
                "eventTarget": ".accordion-item.active a[data-bs-toggle*=collapse]",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentName": "accordion",
                    "componentId": "c01",
                    "eventType": [
                        {
                            "rule": "$(context).parents('.body-content').find('.product-locator').length > 0",
                            "value": "locator accordion expansion click"
                        },
                        {
                            "rule": "$(context).parents('.body-content').find('.product-locator-ff').length > 0",
                            "value": "locator accordion expansion click"
                        },
                        {
                            "rule": "true",
                            "value": "accordion expansion click"
                        }
                    ],
                    "elementType": "accordion expansion box",
                    "elementText": ""
                }
            },
            {
                "eventTarget": ".accordion-item:not(.active) a[data-bs-toggle*=collapse]",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentName": "accordion",
                    "componentId": "c01",
                    "eventType": [
                        {
                            "rule": "$(context).parents('.body-content').find('.product-locator').length > 0",
                            "value": "locator accordion collapse click"
                        },
                        {
                            "rule": "$(context).parents('.body-content').find('.product-locator-ff').length > 0",
                            "value": "locator accordion collapse click"
                        },
                        {
                            "rule": "true",
                            "value": "accordion collapse click"
                        }
                    ],
                    "elementType": "accordion expansion box",
                    "elementText": ""
                }
            }
        ]
    },
    {
        "target": ".component.c01-global-infinite-panels",
        "codeId": "ce",
        "events": [
            {
                "eventTarget": ".accordion-item:not(.accordion-separator).active a[data-bs-toggle*=collapse]",
                "eventType": "click",
                "tags": {
                    "event": "Navigation",
                    "componentName": "content expansion",
                    "componentId": "ce",
                    "eventType": "content expansion click",
                    "elementType": "content expansion link",
                    "elementText": "",
                    "titleText": "",
                    "parentTitle": ""

                }
            },
            {
                "eventTarget": ".accordion-item:not(.accordion-separator):not(.active) a[data-bs-toggle*= collapse]",
                "eventType": "click",
                "tags": {
                    "event": "Navigation",
                    "componentName": "content expansion",
                    "componentId": "ce",
                    "eventType": "content collapse click",
                    "elementType": "content expansion link",
                    "elementText": "",
                    "titleText": "",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": ".accordion-separator.active > .accordion-header a[data-bs-toggle*=collapse]",
                "eventType": "click",
                "tags": {
                    "event": "Navigation",
                    "componentName": "content expansion",
                    "componentId": "ce",
                    "eventType": "content expansion click",
                    "elementType": "content expansion link",
                    "elementText": "",
                    "titleText": "",
                }
            },
            {
                "eventTarget": ".accordion-separator:not(.active) >  .accordion-header a:first-child",
                "eventType": "click",
                "tags": {
                    "event": "Navigation",
                    "componentName": "content expansion",
                    "componentId": "ce",
                    "eventType": "content collapse click",
                    "elementType": "content expansion link",
                    "elementText": "",
                    "titleText": "",
                }
            },
            {
                "eventTarget": ".accordion-body a:not(.accordion-country-a)",
                "eventType": "click",
                "tags": {
                    "componentId": "ce",
                    "componentName": "content expansion",
                    "destinationUrl": "",
                    "elementText": "",
                    "parentTitle": "",
                    "titleText": "",
                    "elementType": "content expansion link",
                    "eventType": [
                        {
                            "rule": "$(context).prop('hostname') !== window.location.hostname",
                            "value": "content outbound click"
                        },
                        {
                            "rule": "true",
                            "value": "content link internal navigation"
                        }
                    ],
                    "event": [
                        {
                            "rule": "$(context).prop('hostname') !== window.location.hostname",
                            "value": "Outbound"
                        },
                        {
                            "rule": "true",
                            "value": "Navigation"
                        }
                    ],
                }
            }
        ]
    },
    {
        "target": ".component.c01-infinite-panels > :not(.global-accordion)",
        "codeId": "ce",
        "events": [
            {
                "eventTarget": ".accordion-item:not(.accordion-separator).active a[data-bs-toggle*=collapse]",
                "eventType": "click",
                "tags": {
                    "event": "Navigation",
                    "componentName": "content expansion",
                    "componentId": "ce",
                    "eventType": "content expansion click",
                    "elementType": "content expansion link",
                    "elementText": "",
                    "titleText": "",


                }
            },
            {
                "eventTarget": ".accordion-item:not(.accordion-separator):not(.active) a[data-bs-toggle*= collapse]",
                "eventType": "click",
                "tags": {
                    "event": "Navigation",
                    "componentName": "content expansion",
                    "componentId": "ce",
                    "eventType": "content collapse click",
                    "elementType": "content expansion link",
                    "elementText": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".accordion-body a:not(.accordion-country-a)",
                "eventType": "click",
                "tags": {
                    "componentId": "ce",
                    "componentName": "content expansion",
                    "destinationUrl": "",
                    "elementText": "",
                    "parentTitle": "",
                    "titleText": "",
                    "elementType": "content expansion link",
                    "eventType": [
                        {
                            "rule": "$(context).prop('hostname') !== window.location.hostname",
                            "value": "content outbound click"
                        },
                        {
                            "rule": "true",
                            "value": "content link internal navigation"
                        }
                    ],
                    "event": [
                        {
                            "rule": "$(context).prop('hostname') !== window.location.hostname",
                            "value": "Outbound"
                        },
                        {
                            "rule": "true",
                            "value": "Navigation"
                        }
                    ],
                    'page_type': 'Distributor Page',
                    'page_title': 'Distributor Locator',
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                    'event1': 'gaCustomEvents_distributor_locator',
                    'eventCategory': 'Customer Enablement & Education',
                    'eventAction': 'Distributor Locator Search',
                    'eventLabel': "",
                    'distributor_search_country': ""
                }
            }
        ]
    },
    {
        "target": ".accordion-group",
        "events": [
            {
                "eventTarget": ".accordion-form-card.active a[data-bs-toggle*=collapse]",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentName": "accordion",
                    "componentId": "c01",
                    "eventType": "accordion expansion click",
                    "elementType": "accordion expansion box",
                    "elementText": ""
                }
            },
            {
                "eventTarget": ".accordion-form-card:not(.active) a[data-bs-toggle*=collapse]",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentName": "accordion",
                    "componentId": "c01",
                    "eventType": "accordion collapse click",
                    "elementType": "accordion expansion box",
                    "elementText": ""
                }
            }
        ]
    }
);

